import { fetchedCurrentLesson } from 'app/models/publishedLessonList/actions';
import { EntityStringId } from 'app/types/entity';
import * as API from 'app/utils/api';
import { AppDispatch } from 'redux';
import { debug } from 'app/services/logger';
import { BookingId } from 'app/models/rtc/booking/constants';
import { fetchEntities } from 'app/models/entities/remote';
import { Lesson } from 'app/constants/schemas';
import { getResponseId } from 'app/remote/response';

export type fetchLessonFunctionType = (
  id: EntityStringId,
  tieupToken: string | undefined,
  lessonBookingId: BookingId | undefined,
) =>
  (dispatch: AppDispatch) => Promise<void>;

export type fetchLessonBoundFunctionType = (
  id: EntityStringId,
  tieupToken: string | undefined,
  lessonBookingId: BookingId | undefined,
) => Promise<void>;

export const fetchCurrentPublishedLesson: fetchLessonFunctionType = (id, tieupToken, lessonBookingId) =>
  async (dispatch: AppDispatch): Promise<void> => {
    const response = await dispatch(fetchEntities({
      params: API.getCurrentPublishedLesson(id, tieupToken, lessonBookingId),
      type: Lesson,
    }));
    dispatch(fetchedCurrentLesson(id, getResponseId(response)));
  };

export const fetchPublishedLesson: fetchLessonFunctionType = (id, tieupToken, lessonBookingId) =>
  async (dispatch: AppDispatch): Promise<void> => {
    if (tieupToken) {
      debug('Given tieup token which will not be used');
    }
    if (lessonBookingId) {
      debug('Given lessonBookingId which will not be used');
    }
    const response = await dispatch(fetchEntities({
      params: API.getLesson(id),
      type: Lesson,
    }));
    dispatch(fetchedCurrentLesson(id, getResponseId(response)));
  };
